module.exports = __webpack_public_path__ + "media/images/icon/icons8-Menu-3370f7c97ec697055d5c4a5ce7fd3608.png";